module.exports = __webpack_public_path__ + "fonts/AvenirHeavy.dc439f4.ttf";